import React from 'react';

import type { Logo as LogoModel } from 'models/offer';

import { useOfferContext } from '../../Offer';

const Logo = ({ logo }: { logo: LogoModel }) => {
  const src = logo.links.original.includes('svg')
    ? logo.links.original
    : logo.links.thumb;

  return <img alt={logo.name} className="Offer-logo" src={src} />;
};

const LogosList = ({ logos = [] }: { logos?: LogoModel[] }) => {
  const { i18n } = useOfferContext();

  if (!logos || !logos.length) {
    return null;
  }

  const renderedLogos = logos.map(logo => <Logo logo={logo} key={logo.name} />);

  return (
    <div className="Offer-logos">
      <span className="Offer-logos__heading">
        {i18n.t('LogosList.supports')}
      </span>
      <div className="Offer-logos__box">{renderedLogos}</div>
    </div>
  );
};

export { LogosList };
